import { render, staticRenderFns } from "./RepositoryCreateRepositoryModal.vue?vue&type=template&id=ecb55120&"
import script from "./RepositoryCreateRepositoryModal.vue?vue&type=script&lang=js&"
export * from "./RepositoryCreateRepositoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports